export enum CoordinateCaptureMethodEnum {
    AUTOMATIC = 'AUTOMATIC',
    MANUAL = 'MANUAL'
}

export const decimalMask = (raw: string) => {
    if (!raw) return '';
    let v = raw.replace(',', '.');
    v = v.replace(/[^0-9.-]/g, '');
    v = v.replace(/(?!^)-/g, '');
    const i = v.indexOf('.');
    if (i !== -1) v = v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, '');
    return v;
};

export function toStrOr<T>(value: T | undefined | null, fallback: string): string {
    return value != null ? String(value) : fallback;
}

export function normalizeMethod(
    m: any,
    fallback: CoordinateCaptureMethodEnum
): CoordinateCaptureMethodEnum {
    if (m === 'MANUAL' || m === CoordinateCaptureMethodEnum.MANUAL) {
        return CoordinateCaptureMethodEnum.MANUAL;
    }
    if (m === 'AUTOMATIC' || m === CoordinateCaptureMethodEnum.AUTOMATIC) {
        return CoordinateCaptureMethodEnum.AUTOMATIC;
    }
    return fallback;
}

export type SigPayload = string | { uuid?: string | null; name?: string } | null | undefined;

export function extractUuidFromSigPayload(payload: SigPayload): string {
    if (typeof payload === 'string') return payload;
    if (payload && typeof payload === 'object' && 'uuid' in payload) return String((payload as any).uuid ?? '');
    return '';
}

export function coordsOk(
    coordinate_capture_method: CoordinateCaptureMethodEnum | string,
    latitudeRaw: string,
    longitudeRaw: string
): boolean {
    const latNum = Number(latitudeRaw);
    const lngNum = Number(longitudeRaw);
    const haveCoords = Number.isFinite(latNum) && Number.isFinite(lngNum);

    if (coordinate_capture_method === CoordinateCaptureMethodEnum.AUTOMATIC) return haveCoords;

    if (coordinate_capture_method === CoordinateCaptureMethodEnum.MANUAL) {
        const lat = parseFloat(String(latitudeRaw).replace(',', '.'));
        const lng = parseFloat(String(longitudeRaw).replace(',', '.'));
        return !Number.isNaN(lat) && !Number.isNaN(lng);
    }

    return false;
}

export function isSignatureFilled(signature_uuid: any): boolean {
    return typeof signature_uuid === 'string' && signature_uuid.trim().length > 0;
}

export default {
    decimalMask,
    toStrOr,
    normalizeMethod,
    extractUuidFromSigPayload,
    coordsOk,
    isSignatureFilled,
};
